import api from "@/lib/api";

// Direct in-page file download — no new tab/window. Fetches with auth
// (cookies + Bearer fallback) and streams the blob through a hidden anchor
// so the file lands in the browser's normal download manager.
export async function downloadFile(url, params, fallbackName = "download.csv") {
  const res = await api.get(url, { params, responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const m = cd.match(/filename="?([^";]+)"?/);
  const name = (m && m[1]) || fallbackName;
  const blobUrl = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
}
